import { Autocomplete, FormControl, InputLabel, MenuItem, Select, TextField, useMediaQuery } from "@mui/material";

import { SkeletonWrapper } from "../../mui-toolkit/SkeletonWrapper";

function CropTypeSelect({ selectedCropType, setSelectedCropType, isLoadingWeather }) {
  const isSmall = useMediaQuery((theme) => theme.breakpoints.down("md"), { noSsr: true });
  const cropOptions = ["corn", "soybeans", "sorghum", "wheat", "cotton", "rice"];

  return (
    <FormControl fullWidth className="data-form">
      <SkeletonWrapper variant="textfield" sx={{ marginBottom: "20px" }} isLoading={isLoadingWeather}>
        {isSmall ? (
          <>
            <InputLabel htmlFor="crop_type">Crop Type</InputLabel>
            <Select
              labelId="crop_type"
              value={selectedCropType}
              multiple={false}
              name="crop_type"
              onChange={(e) => setSelectedCropType(e.target.value)}
              label="Crop Type"
            >
              {cropOptions.map((option) => (
                <MenuItem key={option} value={option}>
                  {option.charAt(0).toUpperCase() + option.slice(1)}
                </MenuItem>
              ))}
            </Select>
          </>
        ) : (
          <Autocomplete
            className="autoComplete"
            sx={{ width: "100%" }}
            name="crop_type"
            value={selectedCropType}
            options={cropOptions}
            getOptionLabel={(option) => option.charAt(0).toUpperCase() + option.slice(1)}
            freeSolo={false}
            disableClearable={true}
            renderInput={(params) => {
              // eslint-disable-next-line no-unused-vars
              const { key, ...inputProps } = params;
              return (
                <TextField
                  {...inputProps}
                  label="Crop Type"
                  name="crop_type"
                  inputProps={{
                    ...params.inputProps,
                    id: null,
                    m: 0,
                    p: 0,
                  }}
                  sx={{ m: 0, p: 0 }}
                />
              );
            }}
            onChange={(event, value) => {
              // Ensure value is never null/undefined
              if (value) {
                setSelectedCropType(value);
              }
            }}
          />
        )}
      </SkeletonWrapper>
    </FormControl>
  );
}

export default CropTypeSelect;
